import React from 'react'

const Work = () => (
  <div className="row work">
    <div className="three columns header-col">
      <h1>
        <span>Work</span>
      </h1>
    </div>

    <div className="nine columns main-col">
      <div className="row item">
        <div className="twelve columns">
          <h3>Meisterwerk</h3>
          <p className="info">
            CTO and Co-founder
            <span>&bull;</span>
            <em className="date">January 2019 - Present</em>
            <span>&bull;</span>
            <a
              href="https://meisterwerk.app"
              target="_blank"
              rel="noopener noreferrer"
            >
              meisterwerk.app
            </a>
          </p>

          <p>
            Owning and executing engineering strategy and activites.
            Focused on building an agile-focused engineering team. Directly
            managing the technical organization and leading software
            development, DevOps, and other technical activities.
          </p>
        </div>
      </div>

      <div className="row item">
        <div className="twelve columns">
          <h3>Birtwell Consulting</h3>
          <p className="info">
            Principal
            <span>&bull;</span>
            <em className="date">April 2016 - Present</em>
            <span>&bull;</span>
            <a
              href="https://birtwellconsulting.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              birtwellconsulting.com
            </a>
          </p>

          <p>
            Birtwell Consulting provides software development and product
            development services for businesses with a focus on domain-driven
            design, agile methodology and feedback-driven customer discovery. We
            specialize in modern web and native technologies, automated
            development operations and cloud computing integrations.
          </p>
        </div>
      </div>

      <div className="row item">
        <div className="twelve columns">
          <h3>Jovio</h3>
          <p className="info">
            Head of Product
            <span>&bull;</span>
            <em className="date">December 2016 - April 2018</em>
            <span>&bull;</span>
            <a
              href="https://jovio.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              jovio.com
            </a>
          </p>

          <p>
            Built and lead Jovio from a 2-person team to an 18-person
            organization in 12 months alongside Founder/CEO. Owned short and
            long-term product decisions weighing stakeholder needs against the
            capacity of the engineering team. Hired and directly managed a
            9-person, agile-focused engineering team: oversaw and actively
            participated in software development, DevOps, QA, deployment, and
            SCRUM rituals. Successfully navigated transfer of outsourced
            software development to in-house team in 4 months.
          </p>
        </div>
      </div>

      <div className="row item">
        <div className="twelve columns">
          <h3>Tidy Translation</h3>
          <p className="info">
            Co-founder | Product
            <span>&bull;</span>
            <em className="date">October 2014 - January 2018</em>
            <span>&bull;</span>
            <a
              href="https://tidytranslation.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              tidytranslation.com
            </a>
          </p>

          <p>
            Designed and developed our mobile-first SPA leveraging the popular
            JavaScript framework AngularJS and PHP framework Laravel later
            refactoring with React and NodeJS. Also employed other technologies
            including LEMP/LAMP, SASS, HTML5, Bootstrap, Adobe CC.
          </p>
        </div>
      </div>

      <div className="row item">
        <div className="twelve columns">
          <h3>Tallan</h3>
          <p className="info">
            Consultant
            <span>&bull;</span>
            <em className="date">March 2014 - September 2014</em>
            <span>&bull;</span>
            <a
              href="https://tallan.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              tallan.com
            </a>
          </p>

          <p>
            Contributed to development of large scale software systems for
            Fortune 500 and Fortune 1000 Clients leveraging .NET technologies.
            Concentration in Microsoft BizTalk, developing, testing, and
            delivering SaaS software to service healthcare industry clients
            working with EDI technology.
          </p>
        </div>
      </div>

      <div className="row item">
        <div className="twelve columns">
          <h3>TRUMPF North America</h3>
          <p className="info">
            Software Engineer
            <span>&bull;</span>
            <em className="date">July 2013 - March 2014</em>
            <span>&bull;</span>
            <a
              href="https://www.trumpf.com/en_US"
              target="_blank"
              rel="noopener noreferrer"
            >
              trumpf.com
            </a>
          </p>

          <p>
            Designed and developed human-machine interface software for
            industrial CNC laser cutting machines. Focus in real-time
            diagnostics software, relaying machine hardware data back to
            engineers to aid in design and troubleshooting of cutting-edge laser
            technology.
          </p>
        </div>
      </div>
    </div>
  </div>
)

export default Work



// WEBPACK FOOTER //
// ./src/components/Work.js